export const ADD_TO_SAVED = "ADD_TO_SAVED";
export const REMOVE_FROM_SAVED = "REMOVE_FROM_SAVED";
export const LOAD_CURRENT_ITEM = "LOAD_CURRENT_ITEM";
export const GET_MINPRICE_VALUE = "GET_MINPRICE_VALUE";
export const GET_MAXPRICE_VALUE = "GET_MAXPRICE_VALUE";
export const GET_MINBEDS_VALUE = "GET_MINBEDS_VALUE";
export const GET_MAXBEDS_VALUE = "GET_MAXBEDS_VALUE";